import { scrollbarWidth } from '@xobotyi/scrollbar-width'
import { useEffect, useState } from 'react'

// Heavily inspired from https://github.com/streamich/react-use/blob/master/src/useScrollbarWidth.ts
export function useScrollbarSize() {
  // Initialize with undefined on SSR. Actual value calculated after hydration
  const [width, setWidth] = useState<number>()

  useEffect(() => {
    // Calculate scrollbar width after mount to avoid hydration mismatch
    const raf = requestAnimationFrame(() => {
      setWidth(scrollbarWidth())
    })

    return () => cancelAnimationFrame(raf)
  }, [])

  return width
}
